module.exports = __webpack_public_path__ + "media/images/user-35864ae7e82770a03449267377af6f6a.png";